export function reloadPage(): void {
  window.location.reload();
}
